export default "__VITE_ASSET__CgPAM366__"